import consumer from "./consumer"

function isActive(subscription) {
  return consumer.subscriptions.subscriptions.includes(subscription)
}

const ChatChannel = {
  subscriptions: {},

  subscribe(conversationId, callbacks) {
    const key = String(conversationId)
    const existing = this.subscriptions[key]

    // Reuse rather than unsubscribe + resubscribe: Rails 6.0 runs those two
    // commands concurrently, and when subscribe lands first the server drops
    // the stream while the client still thinks it is subscribed.
    if (existing && isActive(existing)) {
      existing.callbacks = callbacks
      return existing
    }

    const subscription = consumer.subscriptions.create(
      { channel: "ChatChannel", conversation_id: key },
      {
        callbacks: callbacks,
        hasConnected: false,

        connected() {
          if (this.hasConnected && this.callbacks.onReconnected) this.callbacks.onReconnected()
          this.hasConnected = true
          if (this.callbacks.onConnected) this.callbacks.onConnected()
        },

        disconnected() {
          if (this.callbacks.onDisconnected) this.callbacks.onDisconnected()
        },

        received(data) {
          switch(data.type) {
            case 'new_message':
              if (this.callbacks.onNewMessage) this.callbacks.onNewMessage(data)
              break
            case 'message_undone':
              if (this.callbacks.onMessageUndone) this.callbacks.onMessageUndone(data)
              break
            case 'presence':
              if (this.callbacks.onPresence) this.callbacks.onPresence(data)
              break
            case 'error':
              console.error('Chat error:', data.message)
              if (this.callbacks.onError) this.callbacks.onError(data.message)
              break
          }
        },

        speak(messageData) {
          this.perform('speak', messageData)
        }
      }
    )

    this.subscriptions[key] = subscription
    return subscription
  },

  unsubscribe(conversationId) {
    const key = String(conversationId)
    if (this.subscriptions[key]) {
      this.subscriptions[key].unsubscribe()
      delete this.subscriptions[key]
    }
  },

  sendMessage(conversationId, content, attachments = []) {
    const subscription = this.subscriptions[String(conversationId)]
    if (subscription) {
      subscription.speak({
        conversation_id: conversationId,
        content: content,
        attachments: attachments
      })
    } else {
      console.error('Not subscribed to conversation:', conversationId)
    }
  }
}

export default ChatChannel
